export default __webpack_public_path__ + "static/media/logo-vendor.2ec2a0c2.svg";